(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('leadsService', leadsService);

    function leadsService(sfHttp, config) {

        const baseUrl = config.apiUrl + 'leads';

        this.createFromLead = function (lead) {

            return sfHttp.post(baseUrl, lead, { ignoreLoadingBar: true });
        };

        this.autocompleteLookup = function (search, endpoint) {
            return sfHttp.get(baseUrl + '/' + endpoint, {
                params: {
                    name: search
                }
            });
        };

        this.createTeamJobTitle = (jobName) => {

            const url = baseUrl + '/job_titles';

            return sfHttp.post(url, { name: jobName });
        };

        /**
         * New filter call
         * TODO: make a unified sanitize filter for Http
         *
         * @param {Object} options
         * @param {String} [options.search]
         * @param {Array.<Object>} options.filterRules
         * @param {Number} [options.limit]
         * @param {Number} [options.offset]
         * @param {String} [options.orderBy]
         * @param {Boolean} [options.downloadCSV=false]
         * @param {Boolean} [options.downloadExcel=false]
         * @param {Boolean} [options.returnCountOnly=false]
         * @param {Boolean} [options.includeCount=false]
         * @returns {Promise}
         */
        this.filterGet = function (options) {

            const request = {
                params: {
                    q: {
                        condition: 'AND',
                        rules: options.filterRules
                    }
                },
                noToast: true,
                noToastForStatusCode: [402, 422]
            };

            if (options.limit) {
                request.params.limit = options.limit;
            }

            if (options.offset) {
                request.params.offset = options.offset;
            }

            if (options.orderBy) {
                request.params.order_by = options.orderBy;
            }

            if (options.includeCount) {
                request.headers = { 'x-result-count': 'true' };
            }

            return sfHttp.get(baseUrl, request, { ignoreLoadingBar: false });
        };

        this.getCompanyByLinkedInId = async (linkedInId) => {

            const response = await sfHttp.get(`${baseUrl}/companies`, {
                params: {
                    linkedin_id: linkedInId
                }
            });

            return Object.keys(response.data).length > 0 ? response.data : null;
        };

        this.getPersonByLinkedInId = async (linkedInId) => {

            const response = await sfHttp.get(`${baseUrl}/people`, {
                params: {
                    linkedin_id: linkedInId
                }
            });

            return Object.keys(response.data).length > 0 ? response.data : null;
        };
    }
})();
